import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Stack } from '@phosphor-icons/react';
import { getLevelHeatmap } from '../../lib/api';
import { DaysPicker, SwapSuggestions, heatStyle } from './HeatBits';

const LevelRow = ({ r, max, i }) => (
  <div className="grid grid-cols-[1fr_80px_1.2fr_60px] items-center gap-3 px-3 py-1.5 border-b border-border last:border-b-0 text-xs" data-testid={`level-row-${i}`}>
    <span className="font-bold truncate">{r.tile_label}</span>
    <span className="font-mono">Level {r.level}{r.level_index === 0 ? ' · ground' : ''}</span>
    <div className="h-3 bg-muted relative">
      <div className="h-3" style={{ width: `${max ? (r.picks / max) * 100 : 0}%`, ...heatStyle(r.picks, max) }} />
    </div>
    <span className="font-mono text-right">{r.picks} <span className="text-muted-foreground">({r.pct_of_rack}%)</span></span>
  </div>
);

export const LevelHeatmapDialog = ({ warehouseId, onClose }) => {
  const [days, setDays] = useState(90);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    setData(null);
    getLevelHeatmap(warehouseId, days)
      .then((r) => setData(r.data))
      .catch((e) => setError(e?.response?.data?.detail || 'Could not load heat-map'));
  }, [warehouseId, days]);
  const rows = (data?.rows || []).filter((r) => r.picks > 0);

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-4xl" data-testid="level-heatmap-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between gap-3 pr-6">
            <span className="flex items-center gap-2"><Stack size={16} weight="fill" className="text-brand" /> Level heat-map</span>
            <DaysPicker days={days} onChange={setDays} />
          </DialogTitle>
          <p className="text-xs text-muted-foreground mt-1">Picks per rack level over the last {days} days — busiest first.</p>
        </DialogHeader>
        {error && <p className="text-xs text-red-700">{error}</p>}
        {!data && !error && <p className="text-xs text-muted-foreground">Loading…</p>}
        {data && (
          <div className="space-y-3">
            <div className="border border-border max-h-72 overflow-y-auto" data-testid="level-heatmap-table">
              {rows.length === 0
                ? <p className="p-4 text-xs text-muted-foreground" data-testid="level-heatmap-empty">No picks from linked rack locations in this window.</p>
                : rows.map((r, i) => <LevelRow key={`${r.tile_id}-${r.level_index}`} r={r} max={data.max_level_picks} i={i} />)}
            </div>
            <SwapSuggestions items={data.suggestions} days={days} />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
